import React from 'react';
import { L } from '../../styles/theme';

interface StatusDotProps {
  color: string;
  label: React.ReactNode;
}

/**
 * Статус: сплошная заливка и белый текст (13.10.2026). Точку со словом
 * владелец отверг 25.09 («зачем?!»), пастельную плашку назвал ИИ-слопом.
 * Цвет приходит токеном «Линии» (L.ok / L.warn / L.danger / L.accent),
 * заливка берётся своя, под белый текст; остальное = нейтральная серая.
 */
const TONE: Record<string, string> = {
  [L.ok]: 'pill-ok',
  [L.warn]: 'pill-warn',
  [L.danger]: 'pill-danger',
  [L.accent]: 'pill-info',
};

const StatusDot: React.FC<StatusDotProps> = ({ color, label }) => (
  <span className={`pill ${TONE[color] ?? 'pill-neutral'}`}>{label}</span>
);

export default StatusDot;
